import React, { Component } from 'react'

import DetailRow from './DetailRow'

import last from 'lodash/last'

import './DetailContent.css'

class DetailContent extends Component {

    /* Handlers */

    /* Lifecycle */
     
    render() {

        const data = last(this.props.data)

        return (
            <div className="pages-shared-data-visualizer-detail-content">
                <DetailRow data={data}/>
            </div>       
        )
    }
}

export default DetailContent


// WEBPACK FOOTER //
// ./src/components/pages/shared/data_visualizer/DetailContent.js